import React, { useState, useEffect } from 'react';

const POINT_TYPES = [
    'SPLIT',
    'STAGE',
    'TRACK',
    'START',
    'META',
    'SPEED_CONTROL'
];

const GeofenceModal = ({ geofence, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        area: '',
        attributes: {
            pointType: 'SPLIT',
            stageId: '',
            orderNo: '',
            length: '',
            speedLimit: ''
        }
    });

    useEffect(() => {
        if (geofence) {
            setFormData({
                name: geofence.name || '',
                description: geofence.description || '',
                area: geofence.area || '',
                attributes: {
                    pointType: geofence.attributes?.pointType || 'SPLIT',
                    stageId: geofence.attributes?.stageId || '',
                    orderNo: geofence.attributes?.orderNo || '',
                    length: geofence.attributes?.length || '',
                    speedLimit: geofence.attributes?.speedLimit || ''
                }
            });
        }
    }, [geofence]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith('attr_')) {
            const attrName = name.replace('attr_', '');
            setFormData(prev => ({
                ...prev,
                attributes: {
                    ...prev.attributes,
                    [attrName]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({
            ...geofence,
            ...formData,
            // Clean up empty attributes
            attributes: Object.fromEntries(
                Object.entries(formData.attributes).filter(([_, v]) => v !== '')
            )
        });
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3 className="modal-title">{geofence ? 'Edit Geofence' : 'Add Geofence'}</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        <span className="material-icons-outlined">close</span>
                    </button>
                </div>
                <form onSubmit={handleSubmit} className="modal-body">
                    <div className="form-group">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-input"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Description</label>
                        <textarea
                            name="description"
                            className="form-input"
                            value={formData.description}
                            onChange={handleChange}
                            rows="2"
                        />
                    </div>

                    {/* Attributes Section */}
                    <div className="admin-section-title" style={{ fontSize: '1rem', marginTop: '8px' }}>Attributes</div>

                    <div className="form-group">
                        <label className="form-label">Point Type</label>
                        <select
                            name="attr_pointType"
                            className="form-select"
                            value={formData.attributes.pointType}
                            onChange={handleChange}
                        >
                            {POINT_TYPES.map(type => (
                                <option key={type} value={type}>{type}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Stage ID</label>
                        <input
                            type="number"
                            name="attr_stageId"
                            className="form-input"
                            value={formData.attributes.stageId}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Order No</label>
                        <input
                            type="number"
                            name="attr_orderNo"
                            className="form-input"
                            value={formData.attributes.orderNo}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Speed Control Specifics */}
                    {formData.attributes.pointType === 'SPEED_CONTROL' && (
                        <>
                            <div className="form-group">
                                <label className="form-label">Length (m)</label>
                                <input
                                    type="number"
                                    name="attr_length"
                                    className="form-input"
                                    value={formData.attributes.length}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label">Speed Limit (km/h)</label>
                                <input
                                    type="number"
                                    name="attr_speedLimit"
                                    className="form-input"
                                    value={formData.attributes.speedLimit}
                                    onChange={handleChange}
                                />
                            </div>
                        </>
                    )}

                </form>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default GeofenceModal;
